<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'" >{{collapsed?'':sysName}}<span>v.1.0.1</span></el-col>
      <el-col :span="1">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :span="5" class="breadcrumb-container" >
        <!-- <strong class="title">{{$route.name}}</strong> -->
        <el-breadcrumb separator="/" class="breadcrumb-inner">
          <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>  
      <el-col :span="3" class="userinfo" > 
        <el-dropdown trigger="hover"> 
          <span class="el-dropdown-link userinfo-inner ">
            <div class="imgBox">
              <img :src="this.sysUserAvatar" />
              <div class="userBox">
                <span class="username">{{sysUserName}}</span>
                <span class="RoleId">{{adminRoleId}}</span>
              </div>  
            </div>  
          </span> 
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item @click.native="settings">设置</el-dropdown-item><br>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> 
      </el-col>
      <el-col :span="5" v-if="$route.path == '/charts/echarts'" class="sud">数据刷新: {{minutes}} 分 {{seconds}} 秒</el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo"
          :collapse="collapsed" unique-opened router :collapse-transition="false" >
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden" >
            <el-submenu :index="index+''"  v-if="!item.leaf" >
              <template slot="title">
                <i :class="item.iconCls"></i>
                <span slot="title">{{item.name}}</span>
              </template>
              <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden" >{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>
              <span slot="title">{{item.children[0].name}}</span>
            </el-menu-item>
          </template>
        </el-menu> 
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import baseURL from "@/config/baseUrl";
import { mapState } from "vuex";
import {processRoutingStructure} from '@/utils/index'
// import { requestLogin } from "@/api/api";
export default {
  data() {
    return {
      sysName: "龙杰一拍通",
      collapsed: false,
      sysUserName: "",
      adminRoleId: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      maxtime: 600,
      minutes: null,
      seconds: null,
      menuList:[],
      nodes:this.$router.options.routes
    };
  },
  created() {
    this.CountDown();
    let isLoadNodes = sessionStorage.getItem('isLoadNodes')
    let data = JSON.parse(window.sessionStorage.getItem('menu'))
    if (!isLoadNodes) {
      this.nodes.splice(4,this.nodes.length-4)
      let newData = processRoutingStructure(data)
			this.nodes.push(...newData)
			console.log(this.nodes)
			sessionStorage.setItem('isLoadNodes', 'true')
    }
    console.log(this.$router);
  },
  computed:{
    ...mapState({
       users: state => state.user,
    })
  },
  methods: {
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    //倒计时
    CountDown() {
      var interval = setInterval(() => {
        let obj = null;
        if (this.maxtime >= 0) {
          this.minutes = Math.floor(this.maxtime / 60);
          this.seconds = Math.floor(this.maxtime % 60);
          this.maxtime--;
        } else {
          clearInterval(interval);
          window.location.reload();
        }
      }, 1000);
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
    settings() {
      this.$router.push("/personalData");
    }
  },
  mounted() {
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.username || "";
      this.adminRoleId = user.role_name;
      this.sysUserAvatar = baseURL + "/" + user.avatar || "";
    }
  }
};
</script>

<style scoped lang="scss">
@import "~scss_vars";
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: $color-primary;
    color: #fff;
    .userinfo {
      text-align: right;
      width: 200px;
      height: 60px;
      padding-right: 35px;
      float: right;
      // position: relative; 
      .imgBox{
        width: 160px;
        height: 60px;
        float: right;
        .userBox{
          width: 120px;
          height: 60px;  
          .username{
            line-height: 10px;
            display: block;
            text-align: center; 
            padding-top: 20px;
          }
          .RoleId{  
            line-height: 20px;
            display: block;
            text-align: center; 
            font-size: 1px;
          }
        } 
      }  
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin-top: 10px;
          float: right;
        }
      }
    }
    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;
      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }
      span{
        font-size:6px;
        margin-left: 10px;;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
    .logo-collapse-width {
      width: 64px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
    .sud{
      width: 150px;
      float: right;
    }
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px; 
      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .menu-collapsed {
      flex: 0 0 64px;
      width: 64px;
      overflow: hidden;
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }
    .content-container {
      flex: 1;
      overflow-y: scroll;
      padding: 20px;
      .breadcrumb-container {
        display: flex;
        justify-content: space-between;
        align-items: center; 
        .title {
          width: 200px;
          float: left;
          color: #475669;
          font-size: 18px;
          margin-bottom: 14px;
        }
        .breadcrumb-inner {
          float: right; 
          color: #fff !important;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
} 
.el-breadcrumb { 
    line-height: 60px; 
    font-size: 16px; 
}   
</style>


// WEBPACK FOOTER //
// Home.vue?c0cd089c